import { useEffect, useState } from 'react'
import { collection, getDocs, onSnapshot, query, where } from 'firebase/firestore'
import { db } from '../firebase/config'

/**
 * Dédicaces EN COURS uniquement, pour l'accueil (téléphone et TV).
 *
 * Même règle que la page Dédicaces :
 *  - approuvées par la modération (approved == true)
 *  - pas archivées : ni champ d'archive, ni présentes dans old_dedicaces
 * Triées de la plus récente à la plus ancienne, 20 maximum.
 */

const toMillis = (v) => {
  if (!v) return 0
  if (typeof v.toMillis === 'function') return v.toMillis()
  if (typeof v.toDate === 'function') return v.toDate().getTime()
  const t = new Date(v).getTime()
  return Number.isNaN(t) ? 0 : t
}

const isArchived = (d) =>
  d.archived === true ||
  Boolean(d.archivedAt) ||
  ['archived', 'archive', 'archivée', 'expired'].includes(String(d.status || '').toLowerCase())

export function useCurrentDedicaces(max = 20) {
  const [items, setItems] = useState([])

  useEffect(() => {
    let archivedIds = new Set()
    let latestDocs = []
    let cancelled = false

    const publish = () => {
      if (cancelled) return
      const list = latestDocs
        .filter((d) => !isArchived(d) && !archivedIds.has(d.id))
        .sort((a, b) => toMillis(b.createdAt) - toMillis(a.createdAt))
        .slice(0, max)
        .map((d) => ({
          id: d.id,
          message: d.message || d.text || '',
          from: d.from || d.name || d.dedicatedBy || '',
          to: d.to || d.for || d.dedicatedTo || '',
          song: d.song || d.songTitle || ''
        }))
        .filter((d) => d.message)
      setItems(list)
    }

    // Identifiants déjà archivés (au cas où l'original n'aurait pas été supprimé)
    getDocs(collection(db, '100johnny', 'main', 'old_dedicaces'))
      .then((snap) => {
        archivedIds = new Set(snap.docs.map((d) => d.id))
        publish()
      })
      .catch(() => { /* pas d'accès aux archives : on s'en passe */ })

    // Pas de orderBy côté Firestore : évite d'avoir à créer un index
    const q = query(collection(db, '100johnny', 'main', 'dedicaces'), where('approved', '==', true))
    const unsub = onSnapshot(q, (snap) => {
      latestDocs = snap.docs.map((d) => ({ id: d.id, ...d.data() }))
      publish()
    }, (err) => {
      console.error('Dédicaces en cours :', err)
      setItems([])
    })

    return () => { cancelled = true; unsub() }
  }, [max])

  return items
}
